import { createFileRoute } from '@tanstack/react-router';

import { WeatherEditPage } from '@/components/admin/weather-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetWeatherFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/weather_/$id')({
    component: WeatherEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'יום מזג אוויר חדש' : 'עריכת יום מזג אוויר',
            `/admin/weather/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetWeatherFn({ data: { id: params.id } });
    },
});

function WeatherEditRoute() {
    const weather = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        weather ? `${weather.id}:${String(weather.updatedAt)}` : undefined,
    );
    return <WeatherEditPage key={formKey} weather={weather} />;
}
